module.exports = __webpack_public_path__ + "img/MV_Claim_L_RGB.51676bd1.jpg";